var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_1147_906)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8188 14.2027C26.7774 12.0973 24.1187 10.9373 21.3334 10.9373C18.5454 10.9373 15.8868 12.0973 13.8441 14.204C11.7708 16.3426 10.6321 19.216 10.7214 22.088C10.9734 30.2267 20.5601 36.564 20.9694 36.8293L21.3281 37.0627L21.6907 36.8333C22.0987 36.5747 31.6921 30.3906 31.9454 22.0866C32.0334 19.216 30.8934 16.3413 28.8188 14.2027Z",
    fill: "#4EAE94"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.6836 22.3452C17.6836 24.3572 19.3209 25.9932 21.3329 25.9932C23.3449 25.9932 24.9809 24.3572 24.9809 22.3452C24.9809 20.3331 23.3449 18.6958 21.3329 18.6958C19.3209 18.6958 17.6836 20.3331 17.6836 22.3452Z",
    fill: "#EAEAEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1147_906",
    x: 0.716553,
    y: 0.937317,
    width: 41.2336,
    height: 46.1253,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.305882 0 0 0 0 0.682353 0 0 0 0 0.580392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1147_906"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1147_906",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocationPin);
export default __webpack_public_path__ + "static/media/CurrentLocationPin.b3d9be63e127de2e4116785c6ea54fe5.svg";
export { ForwardRef as ReactComponent };